import React from "react";
import { Link } from "gatsby";
import CaretRight from "../../assets/icons/Caret-right.svg";

export interface AccordionItemData {
  title?: React.ReactNode;
  subtitle?: React.ReactNode | string;
  link?: string;
  search?: string;
  hasChevron?: boolean;
}

type Props = AccordionItemData;

export default function AccordionItem({
  title,
  subtitle,
  link,
  hasChevron,
}: Props) {
  return (
    <div className="w-full px-4 pt-2 flex flex-col font-subtitleTwo relative border-b-4 last:border-b-0">
      <Link to={link || ""}>
        <p className="text-deep-blue">{title}</p>
        <p className="subtitle-3 text-deep-blue opacity-50 border-b-0 pb-2">
          {subtitle}
        </p>
        {hasChevron && (
          <div className="absolute top-5 right-3">
            <CaretRight />
          </div>
        )}
      </Link>
    </div>
  );
}
